import { render, staticRenderFns } from "./CreateShelter.vue?vue&type=template&id=1c36e14b&scoped=true&"
import script from "./CreateShelter.vue?vue&type=script&lang=js&"
export * from "./CreateShelter.vue?vue&type=script&lang=js&"
import style0 from "./CreateShelter.vue?vue&type=style&index=0&id=1c36e14b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36e14b",
  null
  
)

export default component.exports